import { createApp } from 'vue'
import App from './App.vue'
import { provideSocket } from './socket'
import './assets/tailwind.css'

const app = createApp(App)

provideSocket(app)
app.mount('#app')
